import KonfigurasiAngket from "../../../../../../components/categories/siakad/laporan_adab/konfigurasi-angket/subpage/ConfigRekan"
export default function Home() {
  
  return (
    <KonfigurasiAngket />
  );
}
